import "./App.css";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";

import { CssBaseline, ThemeProvider } from "@mui/material";

import RouteLayout from "./routes";
import { store } from "./store";
import theme from "./theme/theme";

import "react-toastify/dist/ReactToastify.css";

const App = () => {
  return (
    <Provider store={store}>
      <div className="App">
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <RouteLayout />
          <ToastContainer position="top-right" autoClose={5000} />
        </ThemeProvider>
      </div>
    </Provider>
  );
};

export default App;
